import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from 'reactstrap';
import useDuplicateQuote from '../../hooks/useDuplicateQuote';
import useCustomersDropdown from '../../hooks/useCustomersDropdown';

export default function DuplicateQuoteModal({ isOpen, onClose, quote }) {
    const navigate = useNavigate();
    const duplicate = useDuplicateQuote();
    const { data: customers, isLoading: customersLoading } = useCustomersDropdown();
    const [customerId, setCustomerId] = useState(null);

    useEffect(() => {
        if (isOpen && quote?.customerId) {
            setCustomerId(quote.customerId);
        }
    }, [isOpen, quote?.customerId]);

    const handleDuplicate = () => {
        if (!quote?.id) return;
        duplicate.mutate({ id: quote.id, customerId }, {
            onSuccess: ({ quoteId }) => {
                onClose();
                navigate(`/quotes/${quoteId}`);
            },
        });
    };

    return (
        <Modal isOpen={isOpen}
               toggle={() => !duplicate.isPending && onClose()}
               centered>
            <ModalHeader toggle={() => !duplicate.isPending && onClose()}>
                Duplicate quote?
            </ModalHeader>
            <ModalBody>
                <p>
                    A new <strong>Draft</strong> quote will be created with the same
                    line items and terms. The original is untouched.
                </p>
                <Label for="duplicate-customer">Customer</Label>
                <Input
                    id="duplicate-customer"
                    type="select"
                    value={customerId ?? ''}
                    onChange={(e) => setCustomerId(Number(e.target.value))}
                    disabled={customersLoading || duplicate.isPending}
                >
                    {customersLoading && <option>Loading...</option>}
                    {customers?.map((c) => (
                        <option key={c.id} value={c.id}>{c.name}</option>
                    ))}
                </Input>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" outline onClick={onClose}
                        disabled={duplicate.isPending}>
                    Cancel
                </Button>
                <Button color="primary" onClick={handleDuplicate}
                        disabled={duplicate.isPending || !customerId}>
                    {duplicate.isPending && <Spinner size="sm" className="me-1" />}
                    Duplicate
                </Button>
            </ModalFooter>
        </Modal>
    );
}
